// extracted by mini-css-extract-plugin
export default {"container":"SLabelTitle_container__NKaKn"};